var Error = {
    MISSING_PARAMS: 'Please fill in the missing fields.',
    EMAIL_MATCH: 'Provided email addresses do not match.',
    PASSWORD_MATCH: 'Provided passwords do not match.',
    EMAIL_ALREADY_REGISTERED: 'This email is already registered',
    EMAIL_NOT_REGISTERED: 'This email is not registered',
    EMAIL_INVALID: 'Provided email address is invalid',
    INTERNAL_GENERAL: 'Internal server error. Please try again later.',
    REGISTRATION_EXPIRED: 'This registration has expired.',
    MISSING_SECRET: 'Missing or invalid secret.',
    PASSWORD_LENGTH: 'Password must be at least eight characters long.',
    PASSWORD_RESET_EXPIRED: 'The request to reset password has expired.',
    FETCH_FAILED_CHANNELS: 'Unable to fetch channels',
    FETCH_FAILED_PROJECTS: 'Unable to fetch projects',
    FETCH_FAILED_ACTIVITIES: 'Unable to fetch activities',
    FETCH_FAILED_TEMPLATES: 'Unable to fetch template data',
    FORBIDDEN: 'Forbidden',
    INVALID_INPUT: 'Invalid input',
    INVALID_TOKEN: 'Invalid Registration Token',
    INVALID_CAPTCHA: 'Invalid captcha. Please retry.',
    INVALID_DATE_RANGE: 'Invalid date range.',
}

module.exports = Error;
